import classNames from "classnames/bind";
import { GalleryObject } from "@/components/Galleries/utils";
import styles from "./Pips.module.scss";

const cx = classNames.bind(styles);

type PipProps = {
  condensedGallery: boolean;
  media: GalleryObject[];
  selectedIndex: number;
};

export const Pips = ({ media, selectedIndex, condensedGallery }: PipProps) => (
  <div className={cx("pipsContainer", { condensedGallery })} aria-hidden="true">
    {media.map((mediaItem, index: number) => {
      const className = cx(styles.pip, {
        selectedPip: index === selectedIndex,
        video: mediaItem.type === "video",
      });

      return (
        <span
          className={className}
          key={`${mediaItem.imageUrl}-${index}`}
        ></span>
      );
    })}
  </div>
);
